import {t} from 'i18next';
import * as React from 'react';
import {ReactElement} from 'react';
import EmbeddedVideo from '../../../../incase-domain/components/EmbeddedVideo';
import MediaVideo from '../../../../incase-domain/components/media/MediaVideo';
import {IElementVideo, VideoSourceType} from '../../../../incase-domain/elements/video';
import {getEmbedUrl} from '../../../../incase-domain/validators/elements/video';

interface ElementVideoProps {
    element: IElementVideo;
}
function ElementVideo(props: ElementVideoProps): ReactElement {
    const {element} = props;
    const {videoSource} = element;

    const getVideo = (): JSX.Element => {
        if (videoSource?.type === VideoSourceType.embedded && videoSource?.src) {
            return <EmbeddedVideo src={getEmbedUrl(videoSource.src)} />;
        }

        return (
            <MediaVideo
                controls
                autoPlay
                loop
                data-testid="video-element"
                src={videoSource?.src || element.videoSrc}
                unsupportedText={t('common.unsupportedVideo')}
            />
        );
    };

    return <div className="c-videoElement">{getVideo()}</div>;
}

export default ElementVideo;
